import React from 'react';

import FertilityIcon from 'assets/icons/fertility.svg?react';
import GynIcon from 'assets/icons/gyn.svg?react';
import MaternityIcon from 'assets/icons/maternity.svg?react';
import WellnessIcon from 'assets/icons/wellness.svg?react';

export const CATEGORY_ICONS = {
  fertility: <FertilityIcon />,
  gynecology: <GynIcon />,
  wellness: <WellnessIcon />,
  maternity: <MaternityIcon />
};
